export default {
  getListCommentOfChecklistItem (state, payload) {
    state.comments = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/comment/mutations.js